import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getTextColor} from '../canvas-timeline/canvas_timeline_util';

class ProjectGroupInfoBox extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showPopup: false,
		};
	}

	render() {
		const {top} = this.props;
		const {showPopup} = this.state;
		const {projects} = this.props;
		const boxHeight = projects.length * 22 + 14;
		const detectionHeight = 25;
		const detectionWidth = 60;
		const popupLeft = 5 + detectionWidth;
		return (
			<div
				onMouseEnter={() => {
					this.setState({showPopup: true});
				}}
				onMouseLeave={() => {
					this.setState({showPopup: false});
				}}
				className="canvas-project-scheduling-project-group-info-box"
				style={{top, height: detectionHeight, width: detectionWidth}}
			>
				{showPopup ? (
					<div className="projects-popup" style={{top: boxHeight / -2 + 8, left: popupLeft}}>
						<div className="triangle-container">
							<div className="triangle" style={{top: boxHeight / 2 - 12}} />
						</div>
						<div className="projects-container">
							{projects.map(project => (
								<div className="project-group-project-row" key={project.id}>
									<div
										className="id-container"
										style={{
											backgroundColor: project.projectColor,
											color: getTextColor(project.projectColor),
										}}
									>
										P{project.companyProjectId}
									</div>
									<div className="project-name">{project.name}</div>
								</div>
							))}
						</div>
					</div>
				) : null}
			</div>
		);
	}
}

ProjectGroupInfoBox.propTypes = {
	top: PropTypes.number.isRequired,
};

export default ProjectGroupInfoBox;
